import React from "react";
import "../../assets/styles/comtwo.css";
import { useNavigate } from "react-router-dom";
import comm3 from "../../assets/images/cableType4.png";
import cm1 from "../../assets/images/cableType1.png";
import cm2 from "../../assets/images/cableType2.png";
import cm4 from "../../assets/images/cableType3.png";
import cm5 from "../../assets/images/cableType5.png";
import { motion } from "framer-motion";

const ComTwo = () => {
  const navigate = useNavigate();

  const handleImageClick = (index) => {
    navigate("/products", { state: { selectedIndex: index } });
  };

  return (
    <div className="solutions-container">
      <motion.h2
        className="title"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      >
        "INNOVATION IN MOTION, SOLUTIONS IN ACTION"
      </motion.h2>
      <motion.p
        className="descriptionnn"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
      >
        At commceed, we don’t just deliver products, we deliver forward-thinking
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        <span className="show-on-mobile"> &nbsp; </span>
        solutions that power your network, elevate your infrastructure, and keep
        you ahead
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        <span className="show-on-mobile"> &nbsp; </span>
        of the curve. With every cable, every connection, and every
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        <span className="show-on-mobile"> &nbsp; </span>
        solution, we ensure reliability, performance, and seamless integration,
        
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        
        empowering your business with the technology needed to thrive in a
        connected world.
        {/* <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span> */}
        {/* <span className="show-on-mobile"> &nbsp; </span>
        provide, we turn complex challenges into seamless experiences
        transforming your ideas into reality with precision and
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        <span className="show-on-mobile"> &nbsp; </span>
        expertise. */}
      </motion.p>

      {/* Image Grid */}
      <div className="solutions-grid">
        <div className="solution-box">
          <img src={cm1} alt="Cable (Copper and Fiber)" />
          <div className="overlay">STRUCTURED CABLING / COPPER & FIBER</div>
        </div>
        <div className="solution-box">
          <img src={cm2} alt="Save Rack and Cable Management" />
          <div className="overlay">NETWORK RACKS / CABINETS / ENCLOSURES</div>
        </div>
        <div className="solution-box">
          <img src={cm5} alt="Networking and SFP" />
          <div className="overlay">NETWORKING / SWITCHING / WIFI & SFP</div>
        </div>
        <div className="solution-box">
          <img src={cm4} alt="Manage Services" />
          <div className="overlay">FIBER / COPPER CABLING TEST EQUIPMENT</div>
        </div>
        <div className="solution-box">
          <img src={comm3} alt="Manage Services" />
          <div className="overlay">MANAGE SERVICES</div>
        </div>
      </div>

      {/* Button */}
      <motion.div
        className="button-container"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.5, ease: "easeInOut", delay: 1 }}
      >
        <motion.button
          className="all-solutions-btn"
          whileHover={{ scale: 1.1 }}
        >
          ALL PRODUCTS
        </motion.button>
      </motion.div>
    </div>
  );
};

export default ComTwo;
